// Global components.
import React, { Component } from 'react';

// Custom components.
import Header from './global/Header';

// Pages.
import Home from '../pages/home/Home';

// Styles.
import '../styles/components/App.scss';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Home />
      </div>
    );
  }
}

export default App;
